import { render, staticRenderFns } from "./FtpAccountForm.vue?vue&type=template&id=265c6030&"
import script from "./FtpAccountForm.vue?vue&type=script&lang=js&"
export * from "./FtpAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('265c6030')) {
      api.createRecord('265c6030', component.options)
    } else {
      api.reload('265c6030', component.options)
    }
    module.hot.accept("./FtpAccountForm.vue?vue&type=template&id=265c6030&", function () {
      api.rerender('265c6030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Ftp/FtpAccountForm.vue"
export default component.exports